type RemoveUndef<T extends Record<string, unknown>> = { [K in keyof T]: Exclude<T[K], undefined> };

export function removeUndefinedValues<T extends Record<string, unknown>>(obj: T): RemoveUndef<T> {
  return Object.fromEntries(Object.entries(obj).filter(([_, value]) => value !== undefined)) as RemoveUndef<T>;
}
